import Alpine from 'alpinejs';
import "../store/email-capture"
import "../components/ai-vet-chat"

(window as typeof window & { Alpine: typeof Alpine }).Alpine = Alpine;

document.addEventListener('alpine:init', () => {

  Alpine.data('common', function() {
    return {
    }
  })

});

Alpine.start();

